import { UsuarioGrupo } from './../models/usuario-grupo';
import { Grupo } from './../models/grupo';
import { Observable } from 'rxjs/Observable';
import { Http, RequestOptions, Headers } from '@angular/http';
import { Injectable } from '@angular/core';

import { environment } from './../../environments/environment';
import { LocalStorageService } from './local-storage.service';
import { AutenticacaoService } from './autenticacao.service';
import { Midia } from './../models/midia';

@Injectable()
export class GrupoService {

 private API_URL: string = environment.apiUrl + "Grupos";

  constructor(
    private http: Http,
    private autenticacaoService: AutenticacaoService,
    private localStorage: LocalStorageService
  ) { }

  public obterGrupo(id: number): Observable<Grupo> {
    return this.http.get(`${this.API_URL}/${id}`)
      .map( response => response.json(), error => error.json() );
  }

  public obterGrupoUsuarios(id: number): Observable<any> {
    return this.http.get(`${this.API_URL}/${id}/usuarios`)
      .map( response => response.json(), error => error.json() );
  }

  public obterGruposFiltro (
    itemOrdenar: string,
    ordenacao: string,
    itensPorPagina: number,
    pagina: number,
    termo: string
  ): Observable<Array<Grupo>> {
    let uri: string;
    if(termo){
      uri = `${this.API_URL}/filtro?itemOrdenar=${itemOrdenar}&ordenacao=${ordenacao}&itensPorPagina=${itensPorPagina}&pagina=${pagina}&termo=${termo}` 
    }else{
      uri = `${this.API_URL}/filtro?itemOrdenar=${itemOrdenar}&ordenacao=${ordenacao}&itensPorPagina=${itensPorPagina}&pagina=${pagina}`
    }
    return this.http.get(uri)
      .map( response => response.json(), error => error.json() );
  }

  public obterListaGrupo(idModulo?: number): Observable<Array<Grupo>> {
    let uri;
    if(idModulo){
      uri = `${this.API_URL}?idModulo=${idModulo}`;
    }else{
      uri = `${this.API_URL}`;
    }
    return this.http.get(uri)
      .map( response => response.json(), error => error.json() );
  }

  public adicionarGrupo(grupo: Grupo): Observable<any> {
    return this.http.post(`${this.API_URL}`, JSON.stringify(grupo))
      .map( response => response.json(), error => error.json() );
  }

  public atualizarGrupo(id:number, grupo: Grupo) : Observable<any>{
    return this.http.put(`${this.API_URL}`, JSON.stringify(grupo))
      .map( response => response.json(), error => error.json() );
  }

  public excluirGrupo(grupos: Array<Grupo>) : Observable<any> {
    return this.http.put(`${this.API_URL}/Delete`, grupos)
      .map( response => response.json(), error => error.json() );
  }
  
  public adicionarUsuariosGrupo(usuarios: Array<UsuarioGrupo>): Observable<any> {
    return this.http.post(`${this.API_URL}/usuarios`, JSON.stringify(usuarios))
      .map( response => response.json(), error => error.json() );
  }
  
  public obterEspecialidades(): Observable<Array<any>> {
    return this.http.get(`${this.API_URL}/especialidades`)
      .map( response => response.json(), error => error.json() );
  }

  public obterQuantidadeGrupos(itensPorPagina: number, termo: string): Observable<number>{
    let uri: string;
    if(termo){
      uri = `${this.API_URL}/quantidade?itensPorPagina=${itensPorPagina}&termo=${termo}` 
    }else{
      uri = `${this.API_URL}/quantidade?itensPorPagina=${itensPorPagina}`
    }
    return this.http.get(uri)
      .map( response => response.json(), error => error.json() );
  }

  public processarArquivoGrupo(formData: FormData, IdModulo: number): Observable<Array<UsuarioGrupo>> {
    let headers = new Headers();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Modulo', IdModulo.toString());
    let options = new RequestOptions({ headers: headers });
    return this.http.post(`${this.API_URL}/carga`, formData, options).map(
      response => response.json(),
      error => error.json()
    );
  }

  public processarArquivoTextoGrupo(formData: FormData, IdModulo: number): Observable<Array<UsuarioGrupo>> {
    let headers = new Headers();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Modulo', IdModulo.toString());
    let options = new RequestOptions({ headers: headers });
    return this.http.post(`${this.API_URL}/carga/texto`, formData, options).map(
      response => response.json(),
      error => error.json()
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/app-services/grupo.service.ts